import React from 'react';
import { Tooltip } from 'antd';
import { usePermissionCheck } from './usePermissionCheck';

export const PermissionOverlay = ({ 
  permissionCheck, 
  permissionMessage, 
  tooltipMessage, 
  children,
  overlayStyle = {},
  ...props 
}) => {
  const { permissionDisabled } = usePermissionCheck(permissionCheck);
  
  const finalTooltipMessage = tooltipMessage || permissionMessage || "You don't have permission to access this feature";
  
  // Default overlay styles
  const defaultOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    zIndex: 1000,
    cursor: 'not-allowed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...overlayStyle
  };

  // If no permission, render children with overlay
  if (permissionDisabled) {
    return (
      <div style={{ position: 'relative', ...props.style }}>
        {children}
        <Tooltip title={finalTooltipMessage}>
          <div 
            style={defaultOverlayStyle}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onMouseUp={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {permissionMessage && (
              <div style={{ 
                textAlign: 'center', 
                color: '#666',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                {permissionMessage}
              </div>
            )}
          </div>
        </Tooltip>
      </div>
    );
  }
  
  // If has permission, render children normally
  return <div style={props.style}>{children}</div>;
};

export default PermissionOverlay; 